import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import Mechcoolhero from "./sections/Mechcoolhero";
import Expertise from "./sections/Expertise";
import CompanyValuesGrid from "./sections/CompanyValuesGrid";
import TargetSectorsGrid from "./sections/TargetSectorsGrid";
import Serviceareas from "./sections/Serviceareas";
import Projectcasestudies from "./sections/Projectcasestudies";
import Services from "./sections/Services";
import Reviews from "./sections/Reviews";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <Mechcoolhero />
      <Expertise />
      <CompanyValuesGrid />
      <TargetSectorsGrid />
      <Serviceareas />
      <Projectcasestudies />
      <Services />
      <Reviews />
      <Footer />
    </div>;
}